import { useState } from "react";
import Groups from "./Groups";
import Projects from "./Projects";
import Models from "./Models";

function Home(props) {
  const raw = localStorage.getItem('tabValue');
  const storedTab = raw === '1' ? 'groups'
    : raw === '0' ? 'projects'
    : ['projects', 'groups', 'models'].includes(raw) ? raw
    : 'projects';
  const [activeTab, setActiveTab] = useState(storedTab);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('tabValue', tab);
  };

  if (activeTab === 'groups') return <Groups {...props} onTab={handleTabChange} />;
  if (activeTab === 'models') return <Models {...props} onTab={handleTabChange} />;
  return <Projects {...props} onTab={handleTabChange} />;
}

export default Home;
